import React from "react";
import { FIELD_REGISTRY } from "./Config/fieldRegistry";

function ProductTaxInformation({
    formData,
    handleChange,
    handleNumberInput,
    errors,
    config
}) {
    const fields = config?.fields?.tax || [];
    if (fields.length === 0) return null;

    return (
        <div className="card mb-3">
            <div className="card-header">
                <h5>Tax Information</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    {fields.map((fieldName) => {
                        const fieldConfig = FIELD_REGISTRY[fieldName];
                        console.log("field names",fieldConfig)
                        if (!fieldConfig) return null;

                        const { type, label, required, placeholder } = fieldConfig;

                        return (
                            <div className="col-md-6 mb-3" key={fieldName}>
                                <label className="form-label">
                                    {label} {required && <span className="text-danger">*</span>}
                                </label>
                                <input
                                    type={type == 'number' ? 'number' : 'text'}
                                    className={`form-control ${errors?.[fieldName] ? "is-invalid" : ""}`}
                                    placeholder={placeholder || `Enter ${label}`}
                                    name={fieldName}
                                    value={formData[fieldName] || ""}
                                    onChange={type === 'number' ? handleNumberInput : handleChange}
                                />
                                {errors?.[fieldName] && (
                                    <div className="invalid-feedback">{errors[fieldName]}</div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default ProductTaxInformation;